module.exports = __webpack_public_path__ + "resources/img/img_tcc_advantage6.1d54f90090eb7b3f06e16af61bf2e852.jpg";